// extracted by mini-css-extract-plugin
export default {"checkbox":"q5R3_Z"};